import AdminProTable from '@/components/admin-pro-table';
import { useRequest } from 'ahooks';
import { App, Drawer } from 'antd';
import { FormattedMessage } from 'react-intl';

import { logsByBizId } from '@/services/logs';
import type { LogsResponse } from '@/services/logs';

type Props = {
    open: boolean;
    bizId: string | null;
    onClose: () => void;
};

const OperationLogDrawer: React.FC<Props> = ({ open, bizId, onClose }) => {
    const { message } = App.useApp();

    const { data: response, loading } = useRequest(
        () =>
            bizId
                ? logsByBizId(bizId).then((r) => r.data)
                : Promise.resolve({ code: 200, data: [], msg: '' }),
        {
            ready: open && !!bizId,
            refreshDeps: [open, bizId],
            onError: (e) => {
                message.error((e as any)?.response?.data?.msg ?? '获取操作记录失败');
            },
        },
    );

    const code = response?.code;
    const data = Array.isArray(response?.data) ? response.data : [];

    return (
        <Drawer
            destroyOnClose
            open={open}
            onClose={onClose}
            title="操作记录"
            width={900}
        >
            <AdminProTable<LogsResponse>
                bordered
                columns={[
                    { dataIndex: 'index', title: 'No.', valueType: 'index', width: 50 },
                    { dataIndex: 'ip', title: 'IP', width: 120 },
                    { dataIndex: 'action', title: <FormattedMessage id="t.c.type" />, width: 100 },
                    { dataIndex: 'module', title: <FormattedMessage id="p.logs.t.c.menu" />, width: 100, ellipsis: true },
                    { dataIndex: 'path', title: 'Path', width: 160, ellipsis: true },
                    {
                        dataIndex: 'body',
                        title: <FormattedMessage id="p.logs.t.c.body" />,
                        ellipsis: true,
                        render: (t) => (t != null ? JSON.stringify(t) : '-'),
                    },
                    { dataIndex: 'status', title: <FormattedMessage id="p.logs.t.c.result" />, width: 80 },
                    { dataIndex: 'account_id', title: <FormattedMessage id="t.c.operatedBy" />, width: 120 },
                    { dataIndex: 'created_at', title: <FormattedMessage id="t.c.operatedAt" />, valueType: 'dateTime', width: 170 },
                ]}
                dataSource={code === 200 ? data : []}
                loading={loading}
                rowKey="id"
                search={false}
                pagination={false}
                size="small"
                scroll={{ x: 800 }}
            />
        </Drawer>
    );
};

export default OperationLogDrawer;
